import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Ignore requests that explicitly opt out or common background polling/SSE patterns.
  if (req.headers.has('X-Skip-Loader')) {
    return next(req);
  }

  loadingService.start();

  return next(req).pipe(
    finalize(() => loadingService.stop())
  );
};
